<template>
  <div class="modal-card" style="margin: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{
          operation === "add" ? $t("vending.addSlot") : $t("vending.editSlot")
        }}
      </p>
    </header>

    <section class="modal-card-body">
      <div class="columns">
        <div class="column">
          <b-field :label="$t('vending.number')" label-position="on-border">
            <b-select :placeholder="$t('common.select')" v-model="sl.n">
              <option value="">
                {{ $t("common.select") }}
              </option>

              <option v-for="s in avaiableSlots" :value="s" :key="s">
                {{ s }}
              </option>
            </b-select>
          </b-field>
        </div>

        <!-- <div class="column">
          <b-field :label="$t('vending.type')" label-position="on-border">
            <div class="block" style="position: relative; top: 10px;">
              <b-radio v-model="sl.t" name="sl.t" native-value="spring">
                {{ $t("vending.spring") }}
              </b-radio>

              <b-radio v-model="sl.t" name="sl.t" native-value="belt">
                {{ $t("vending.belt") }}
              </b-radio>
            </div>
          </b-field>
        </div> -->

        <div class="column">
          <b-field :label="$t('vending.currentQty')" label-position="on-border">
            <b-input type="tel" v-model="sl.cq" style="width: 70px"></b-input>
          </b-field>
        </div>
      </div>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>

      <button
        v-if="operation === 'add'"
        class="button"
        :style="{
          backgroundColor: $primaryColor,
          color: $primaryColorContrast
        }"
        type="button"
        @click="addSlot"
      >
        {{ $t("common.add") }}
      </button>

      <button
        v-if="operation === 'edit'"
        class="button"
        :style="{
          backgroundColor: $primaryColor,
          color: $primaryColorContrast
        }"
        type="button"
        @click="updateSlot"
      >
        {{ $t("common.save") }}
      </button>

      <button
        v-if="operation === 'edit'"
        class="button is-deep-purple"
        style="position: absolute; right: 1rem;"
        type="button"
        @click="deleteSlot"
      >
        {{ $t("common.delete") }}
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  props: ["product", "slotInfo", "operation", "vending", "slotIndex"],

  data() {
    return {
      sl: {
        n: null,
        mq: 10,
        cq: 0,
        d: false,
        t: "spring",
        _id: null
      },
      avaiableSlots: []
    };
  },

  methods: {
    addSlot() {
      this.$store.commit("ADD_SLOT_TO_PRODUCT", {
        product: this.product,
        slot: this.sl,
        vendingId: this.vending._id
      });
      this.$emit("update-vending");
      this.$emit("show-save-changes-button");
      this.$parent.close();
    },

    updateSlot() {
      this.$store.commit("UPDATE_PRODUCT_SLOT", {
        product: this.product,
        slot: this.sl,
        vendingId: this.vending._id,
        slotIndex: this.slotIndex
      });
      this.$emit("update-vending");
      this.$emit("show-save-changes-button");
      this.$parent.close();
    },

    deleteSlot() {
      this.$buefy.dialog.confirm({
        title: this.$t("vending.removeSlotTitle"),
        message: this.$t("vending.removeSlotMessage"),
        confirmText: this.$t("common.yes"),
        cancelText: this.$t("common.cancel"),
        type: "is-primary",
        onConfirm: () => {
          this.$store.commit("DELETE_PRODUCT_SLOT", {
            product: this.product,
            slot: this.sl,
            vendingId: this.vending._id
          });
          this.$emit("update-vending");
          this.$emit("show-save-changes-button");
          this.$parent.close();
        }
      });
    }
  },

  mounted() {
    if (this.operation === "edit") {
      this.sl = JSON.parse(JSON.stringify(this.slotInfo));
    }

    const min = !isNaN(this.vending.vendingConfig.minSlotNumber)
      ? this.vending.vendingConfig.minSlotNumber
      : 1;

    const max = !isNaN(this.vending.vendingConfig.maxSlotNumber)
      ? this.vending.vendingConfig.maxSlotNumber
      : 60;

    const avaiableSlots = [];

    for (let i = min; i < max + 1; i++) {
      avaiableSlots.push(i);
    }

    const slotsInUse = [];

    for (let i = 0; i < this.vending.products.length; i++) {
      for (let j = 0; j < this.vending.products[i].sl.length; j++) {
        slotsInUse.push(this.vending.products[i].sl[j].n);
      }
    }

    if (this.operation === "edit") {
      const index = slotsInUse.findIndex(s => Number(s) === Number(this.sl.n));
      slotsInUse.splice(index, 1);
    }

    slotsInUse.sort((a, b) => a - b).reverse();

    for (let i = 0; i < slotsInUse.length; i++) {
      avaiableSlots.splice(slotsInUse[i] - 1, 1);
    }

    this.avaiableSlots = avaiableSlots;
  }
};
</script>
